import { AlertTriangle, CheckCircle2, Star } from "lucide-react";

import { Badge } from "@/components/ui/badge";

import {
  channelLabel,
  contactDisplayName,
  hasActiveFunnelError,
  isRecoveredFunnelContact,
  stuckDays,
  type FunnelBoardContact,
} from "./funnelBoard";

export function FunnelContactCard({
  contact,
  onSelect,
}: {
  contact: FunnelBoardContact;
  onSelect: (contact: FunnelBoardContact) => void;
}) {
  const days = stuckDays(contact.stage_entered_at);
  const hasError = hasActiveFunnelError(contact);
  const recovered = isRecoveredFunnelContact(contact);
  const rating = contact.average_rating ?? contact.last_rating ?? null;
  const acquisitionGroup = contact.acquisition_group ?? "unknown";

  return (
    <button
      type="button"
      onClick={() => onSelect(contact)}
      className="w-full rounded-md border bg-card p-3 text-left transition-colors hover:bg-muted focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <div className="flex items-center justify-between gap-2">
        <span className="truncate text-sm font-medium">
          {contactDisplayName(contact)}
        </span>
        {hasError ? (
          <AlertTriangle
            className="size-4 shrink-0 text-destructive"
            aria-label="Echo error"
          />
        ) : recovered ? (
          <Badge
            variant="outline"
            className="gap-1 border-emerald-500/40 text-emerald-700 dark:text-emerald-400"
          >
            <CheckCircle2 className="size-3" aria-hidden="true" />
            Recovered
          </Badge>
        ) : null}
      </div>
      <div className="mt-1.5 flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
        <Badge variant="outline" className="font-normal">
          {channelLabel(contact.acquisition_channel)}
        </Badge>
        <Badge
          variant={acquisitionGroup === "unknown" ? "outline" : "secondary"}
          className="font-normal capitalize"
        >
          {acquisitionGroup}
        </Badge>
        {days != null ? (
          <span className="tabular-nums">stuck {days}d</span>
        ) : null}
        {rating != null ? (
          <span className="inline-flex items-center gap-0.5 tabular-nums">
            <Star className="size-3 fill-current" />
            {rating}
          </span>
        ) : null}
      </div>
    </button>
  );
}
